import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import { GuideCard, VideoThumbnail } from '@hotjar/activation-toolkit';
import { Stack, Button, tokens } from '@hotjar/hotsauce';
import TRENDS_SPLASH from '@hotjar/shared-assets/images/trends-splash.svg';
import { useGuideCardVisibility } from '@hotjar/webapp/hooks/useGuideCardVisibility';
import { useHelpHotjarUrl } from '@hotjar/translations';

const TRENDS_KB_URL = '/articles/6644761329303';
const VIDEO_URL = 'https://www.youtube.com/embed/SE59AnSXt9Y?autoplay=1';
const VIDEO_DURATION = '1:07';

const WrapperDiv = styled.div`
  margin-bottom: ${tokens.spacer.x4};
`;

export const ScaleTrialGuideCard = (): React.ReactElement | null => {
  const { t } = useTranslation('dashboard-quantz');
  const helpHotjarUrl = useHelpHotjarUrl();
  const { isGuideCardVisible, dismissGuideCard } = useGuideCardVisibility(
    'scale-trial-trends-intro',
  );

  return (
    <>
      {isGuideCardVisible && (
        <WrapperDiv>
          <GuideCard
            label={t('TrendsPage.trialGuide.label')}
            title={t('TrendsPage.trialGuide.title')}
            description={
              <div style={{ whiteSpace: 'pre-line' }}>{t('TrendsPage.trialGuide.description')}</div>
            }
            media={
              <VideoThumbnail
                modalContentLabel="Trial Guide Video Modal"
                duration={VIDEO_DURATION}
                videoUrl={VIDEO_URL}
                thumbnail={TRENDS_SPLASH}
                title={t('TrendsPage.trialGuide.videoTitle')}
              />
            }
            onDismiss={dismissGuideCard}
            actions={
              <Stack direction="row">
                <Button
                  as="a"
                  href={`${helpHotjarUrl}${TRENDS_KB_URL}`}
                  kind="secondary"
                  isExternal
                  icon="open_new_window"
                >
                  {t('TrendsPage.trialGuide.moreAboutTrends')}
                </Button>
                <Button onClick={dismissGuideCard} kind="ghost">
                  {t('TrendsPage.trialGuide.dismiss')}
                </Button>
              </Stack>
            }
          />
        </WrapperDiv>
      )}
    </>
  );
};
